
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerEditor("Matrix.Rebalancer.SummaryViewAccountGrid", [Serenity.IReadOnly])
    @Serenity.Decorators.element("<div/>")
    export class SummaryViewAccountGrid extends SiteEntityGrid<SummaryViewAccountRow, any>
        implements Serenity.IReadOnly {
        protected getColumnsKey() { return 'Rebalancer.SummaryViewAccount'; }
        protected getDialogType() { return SummaryViewAccountDialog; }
        protected getIdProperty() { return SummaryViewAccountRow.idProperty; }
        protected getLocalTextPrefix() { return SummaryViewAccountRow.localTextPrefix; }
        protected getService() { return SummaryViewAccountService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        private _readOnly: boolean;

        get_readOnly(): boolean {
            return !!this._readOnly;
        }

        set_readOnly(value: boolean): void {
            if (!!this._readOnly !== !!value) {
                this._readOnly = !!value;
                this.updateInterface();
            }
        }

        protected updateInterface() {
            this.toolbar.findButton('add-button').toggle(!this._readOnly && !!this._instanceCode);
        }

        private _instanceCode: string;

        public set instanceCode(value: string) {
            if (this._instanceCode !== value) {
                this._instanceCode = value;
                this.setEquality(SummaryViewAccountRow.Fields.InstanceCode, value);
                this.refresh();
            }
        }

        protected addButtonClick() {
            this.editItem(<SummaryViewAccountRow>{
                InstanceCode: this._instanceCode
            });
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._instanceCode;
        }
    }
}